export default "__VITE_ASSET__CbYeq43j__"